module.exports = __webpack_public_path__ + "img/bgr-tickets.0a912b30.png";